import { Component, OnInit, ViewChild, ElementRef, ViewChildren, QueryList} from '@angular/core';
import { ForgotService } from '../shared/Forgot.Service';
import { Router } from '@angular/router';
import { Forgot } from '../shared/forgot.model';
import { AppInsightsService } from '../shared/AppInsights.Service';

@Component({
  selector: 'app-new-question',
  templateUrl: './new-question.component.html',
  styleUrls: ['./new-question.component.scss']
})
export class NewQuestionComponent implements OnInit {
  public questions: any = ['test','test','test'];
  public answers: any = ['','',''];
  public quesIndex = [];
  public forgot: Forgot;
  public type = '';
  public userType = '';
  public error = false;
  public message = '';
  public showPlaceholder: boolean;
  public isLoading = false;
  public validate = true;
  public formErrorFields: any = {
    answers: [false, false, false]
  };
  constructor(private forgotService: ForgotService, private router: Router, private appInsightsService: AppInsightsService) { }
  
  @ViewChildren('anws') anws: QueryList<any>;

  ngOnInit() {
  	window.scroll(0,0);
  	this.showPlaceholder = true;
  	this.appInsightsService.logEvent("Forgot UI Page - Questions Page");
    this.forgotService.getQuestions().subscribe(res => {
      this.questions = res;
    });
    this.forgotService.getType().subscribe(res => {
      this.type = res;
    });
    this.forgotService.getUserType().subscribe(res => {
      this.userType = res;
    });
    this.forgotService.getQuesIndex().subscribe(res => {
      this.quesIndex = res;
    });
    if (this.questions.length === 1) {
    	this.formErrorFields.answers = [false];
    } else if (this.questions.length === 2) {
    	this.formErrorFields.answers = [false, false];
    } else if (this.questions.length === 3) {
    	this.formErrorFields.answers = [false, false, false];
    } else {
    	this.formErrorFields.answers = [];
    }
  }
  
  setPlaceholder(ele) {
    ele.setAttribute('placeholder', '');
  }
  
  togglePlaceholder(event: FocusEvent) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
  }
  
  focusOnInput() {
    let setError = false;
    if (!!this.formErrorFields.answers[0] || !!this.formErrorFields.answers[1] || !!this.formErrorFields.answers[2]) {
      for (let j = 0; j < this.anws.toArray().length; j++) {
        if (!!this.formErrorFields.answers[j]) {
          setError = true;
          setTimeout(() => this.anws.toArray()[j].nativeElement.focus(), 0);
          setTimeout(() => this.anws.toArray()[j].nativeElement.select(), 0);
          window.scrollTo(0,this.anws.toArray()[j].nativeElement.getBoundingClientRect().top + window.scrollY - 150);
          break;
        }
      }
    } 

    return setError;
  }

  isErrorPresent() {
  	let allFalse = this.formErrorFields.answers.every(v => !v);
  	return !allFalse;
  }
  
  isAllFieldFilled() {
  	let allTrue = this.answers.every(v => !!v);
  	return allTrue;
  }

  validateAllFields() {
    let isErrPresent = false;
    for (let k = 0; k < this.formErrorFields.answers.length; k++) {
		isErrPresent = this.validateForm('answers', k);
		if (isErrPresent) {
			break;
		}
    }
    return isErrPresent;
  }

  ifAtleastOneFieldValidatedIndex(model, index) {
    this.validate = !!this[model][index] ? false : true;
    return this.validate;
  }

  validateForm(model, index) {
    let error = false;
    this.validate = true;
 
    if (model === 'answers' && index === 0) {
      if (!this.answers[0]) {
        this.formErrorFields.answers[0] = true;
        error = true;
      } else {
        this.formErrorFields.answers[0] = false;
        this.ifAtleastOneFieldValidatedIndex(model, index);
      }
    }

    if (model === 'answers' && index === 1) {
      if (!this.answers[1]) {
        this.formErrorFields.answers[1] = true;
        error = true;
      } else {
        this.formErrorFields.answers[1] = false;
        this.ifAtleastOneFieldValidatedIndex(model, index);
      }
    }

    if (model === 'answers' && index === 2) {
      if (!this.answers[2]) {
        this.formErrorFields.answers[2] = true;
        error = true;
      } else {
        this.formErrorFields.answers[2] = false;
        this.ifAtleastOneFieldValidatedIndex(model, index);
      }
    }

    if (this.isAllFieldFilled() && !this.isErrorPresent() && !error) {
      this.validate = error;
    }
    return error;
  }
  
  next() {
    if (!this.validateAllFields()) {
      setTimeout(() => {
        window.scroll(0, 0);
        this.error = false;
        this.isLoading = true;
        this.validate = true;
      });     
      if (this.type && this.type === 'uid') {
        this.forgotService.uidAns(this.answers, this.questions).subscribe(res => {
          this.forgot = res;
          if (this.forgot) {           
            if (this.forgot.status_code === '200') {             
              this.forgotService.setUid(this.forgot.userId);          
              if (this.forgot.url && this.forgot.url.indexOf('/login') !== -1 ) {
                window.location.href = window.location.origin + this.forgot.url;
              } else {
                this.router.navigate(['/eb']);
              }
              this.error = false;
            } else {
              setTimeout(() => {
	              this.isLoading = false;
	          });
              if (this.forgot.message) {
                this.message = this.forgot.message;
              } else {
                this.message = 'Session has expired please close browser and try again';
              }
              this.error = true;
              this.validate = false;
              window.scroll(0,0);
            }
          }
        });
      } else {
        this.forgotService.validateAns(this.answers, this.questions, this.userType, this.quesIndex).subscribe(res => {
          this.forgot = res;
          if (this.forgot) {
            if (this.forgot.status_code === '200') {
                	if(this.router.url.indexOf('ces') !== -1){
                    this.router.navigate(['/ces/createPwd']);  
                    }else{
                     this.router.navigate(['/createPwd']); 
                    }
              this.error = false;
            } else {
              setTimeout(() => {
                this.isLoading = false;
              });
              if (this.forgot.message) {
                this.message = this.forgot.message;
              } else {
                this.message = 'Session has expired please close browser and try again';
              }
              this.error = true;
              this.validate = false;
              window.scroll(0,0);
            }
          }
        });
      }
    } else {
      this.focusOnInput();
    }
  }
}
